<template>
  <div class="d-flex" :class="{ 'align-center': progressBars.length === 1 }" style="width: 100%; gap: 8px">
    <div class="d-flex flex-column">
      <div v-for="(bar, index) in progressBars" :key="index">
        <b>{{ bar.label }}:</b>
      </div>
    </div>
    <div class="d-flex flex-column align-end" style="width: 35px">
      <div v-for="(bar, index) in progressBars" :key="index">
        {{ Math.floor(bar.total) }}%
      </div>
    </div>
    <div class="d-flex flex-column flex-grow-1">
      <div v-for="(bar, index) in progressBars" :key="index" class="d-flex align-center" style="height: 21px">
        <percent-bar
          :total="bar.total"
          :automatica="bar.automatica"
          :manual="bar.manual"
          :textAutomatica="bar.textAutomatica"
          :textManual="bar.textManual"
          :textRestante="bar.textRestante"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PercentBar from './PercentBar.vue'

/**
 * Expected element of progressBars array:
 * {
 *   label: String,
 *   total: Number,
 *   automatica: Number,
 *   manual: Number,
 *   textAutomatica: String,
 *   textManual: String,
 *   textRestante: String
 * }
 */
export default {
  components: {
    PercentBar
  },
  props: {
    progressBars: Array
  }
}
</script>
